import { Component, OnInit, AfterViewInit, ElementRef, ViewChild, Input, OnChanges } from '@angular/core';
import MetisMenu from 'metismenujs';
import { EventService } from '../../core/services/event.service';
import { Router, NavigationEnd } from '@angular/router';

import { HttpClient } from '@angular/common/http';

import { MENU, MENUADMIN } from './menu';
import { MenuItem } from './menu.model';
import { TranslateService } from '@ngx-translate/core';

import { PermissionService } from '../../core/services/permission.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})

/**
 * Sidebar component
 */
export class SidebarComponent implements OnInit, AfterViewInit, OnChanges {
  @ViewChild('componentRef') scrollRef;
  @Input() isCondensed = false;
  menu: any;
  data: any;
  usuario:any;
  elementosAEliminar  = []

  menuItems: MenuItem[] = [];
  menuAdmin: MenuItem[] = [];

  @ViewChild('sideMenu') sideMenu: ElementRef;

  constructor(
      private eventService: EventService, 
      private router: Router, 
      public translate: TranslateService, 
      private http: HttpClient,
      private permissionService: PermissionService
    ) {
    this.usuario = localStorage.getItem('currentUser');
    this.usuario = JSON.parse(this.usuario);
    router.events.forEach((event) => {
      if (event instanceof NavigationEnd) {
        this._activateMenuDropdown();
        this._scrollElement();
      }
    });
  }

  ngOnInit() {    
    this.initialize();
    this.permissionService.permissions$.subscribe(() => {
      this.initialize();
    });
    this._scrollElement();
  }

  ngAfterViewInit() {
    this.menu = new MetisMenu(this.sideMenu.nativeElement);
    this._activateMenuDropdown();
  }

  toggleMenu(event) {
    event.currentTarget.nextElementSibling.classList.toggle('mm-show');
  }

  ngOnChanges() {
    if (!this.isCondensed && this.sideMenu || this.isCondensed) {
      setTimeout(() => {
        this.menu = new MetisMenu(this.sideMenu.nativeElement);
      });
    } else if (this.menu) {
      this.menu.dispose();
    }
  }
  _scrollElement() {
    setTimeout(() => {
      if (document.getElementsByClassName("mm-active").length > 0) {
        const currentPosition = document.getElementsByClassName("mm-active")[0]['offsetTop'];
        if (currentPosition > 500)
        if(this.scrollRef.SimpleBar !== null)
          this.scrollRef.SimpleBar.getScrollElement().scrollTop =
            currentPosition + 300;
      }
    }, 300);
  }

  /**
   * remove active and mm-active class
   */
  _removeAllClass(className) {
    const els = document.getElementsByClassName(className);
    while (els[0]) {
      els[0].classList.remove(className);
    }
  }

  /**
   * Activate the parent dropdown
   */
  _activateMenuDropdown() {
    this._removeAllClass('mm-active');
    this._removeAllClass('mm-show');
    var links:any = document.getElementsByClassName('side-nav-link-ref');
    
    //valido que exista un usuario
    if(this.usuario){ 
      // Logic removed: Legacy DOM manipulation for hiding menu items
    }    
    let menuItemEl = null;
    const paths = [];
    for (let i = 0; i < links.length; i++) {
      paths.push(links[i]['pathname']);
    }
    var itemIndex = paths.indexOf(window.location.pathname);    
    if (itemIndex === -1) {
      const strIndex = window.location.pathname.lastIndexOf('/');
      const item = window.location.pathname.substr(0, strIndex).toString();
      menuItemEl = links[paths.indexOf(item)];      
    } else {
      menuItemEl = links[itemIndex];      
    }
    if (menuItemEl) {
      menuItemEl.classList.add('active');
      const parentEl = menuItemEl.parentElement;
      if (parentEl) {
        parentEl.classList.add('mm-active');
        const parent2El = parentEl.parentElement.closest('ul');
        if (parent2El && parent2El.id !== 'side-menu') {
          parent2El.classList.add('mm-show');
          const parent3El = parent2El.parentElement;
          if (parent3El && parent3El.id !== 'side-menu') {
            parent3El.classList.add('mm-active');
            const childAnchor = parent3El.querySelector('.has-arrow');
            const childDropdown = parent3El.querySelector('.has-dropdown');
            if (childAnchor) { childAnchor.classList.add('mm-active'); }
            if (childDropdown) { childDropdown.classList.add('mm-active'); }
            const parent4El = parent3El.parentElement;
            if (parent4El && parent4El.id !== 'side-menu') {
              parent4El.classList.add('mm-show');
              const parent5El = parent4El.parentElement;
              if (parent5El && parent5El.id !== 'side-menu') {
                parent5El.classList.add('mm-active');
                const childanchor = parent5El.querySelector('.is-parent');
                if (childanchor && parent5El.id !== 'side-menu') { childanchor.classList.add('mm-active'); }
              }
            }
          }
        }
      }
    }
  }

  /**
   * Initialize
   */
  initialize(): void {
    // Deep clone to avoid mutating original MENU constants
    this.menuItems = this.filterMenuItems(JSON.parse(JSON.stringify(MENU)));
    this.menuAdmin = this.filterMenuItems(JSON.parse(JSON.stringify(MENUADMIN)));

    if (this.usuario && this.usuario.user && this.usuario.user.role !== 0 && this.usuario.role !== 'Admin') {
      const adminIds = [8, 9, 10, 11, 12, 14];
      this.menuItems = this.menuItems.filter(item => !adminIds.includes(item.id));
    }
    
    // Refresh MetisMenu if it exists
    if (this.menu) {
      setTimeout(() => {
        this.menu.dispose();
        this.menu = new MetisMenu(this.sideMenu.nativeElement);
      });
    }
  }

  filterMenuItems(items: MenuItem[]): MenuItem[] {
    return items.filter(item => {
      // If it's a title, we usually keep it unless specified
      if (item.isTitle) {
          return true;
      }
      
      if (item.permission && !this.permissionService.hasPermission(item.permission)) {
        return false;
      }
      
      if (item.subItems) {
        item.subItems = this.filterMenuItems(item.subItems);
        return item.link || item.subItems.length > 0;
      }
      return true;
    });
  }

  /**
   * Returns true or false if given menu item has child or not
   * @param item menuItem
   */
  hasItems(item: MenuItem) {
  return Array.isArray(item.subItems) && item.subItems.length > 0;
}
}
